import BasketItem from "../../booking/types/BasketItem";
import {extractIdFromPath} from "../../transfers/utils/extractIdFromPath";

export const useIsRoomSelected = (roomId: number, preBookingHotelRooms?: BasketItem[]): boolean => {
  if (!preBookingHotelRooms || preBookingHotelRooms.length === 0) {
    return false;
  }

  return preBookingHotelRooms.some((room) => {
    const extractedId = parseInt(extractIdFromPath(room.roomHotelEvent as any), 10);
    return extractedId === roomId;
  });
};

